import $ from "jquery";
import { AimWarn } from "#scripts/tools/aimlog.js";
import { checkValidPath, getPageUrl } from "#scripts/general_functions.js";
import { headerNav, storeNav, navPage } from "#scripts/nav.js";
import header from "#templates/body/header";
import footer from "#templates/body/footer";
import { getTemplateContent } from "#scripts/templateDispatcher.js";
// import article from "#templates/pages/article";
// import frontpage from "#templates/pages/frontpage";
// import { calendarpage, calendarpageCustom } from "#templates/pages/eventlist";
import list from "#templates/pages/list";
// import fullsearchHive from "#templates/pages/search_haive";
// import fullsearchTellusR from "#templates/pages/search_tellusr";
// import { event, eventCustom } from "#templates/pages/event.js";
import { minside } from "#templates/pages/minside";
// import { sitemappage } from "#templates/pages/sitemap/sitemap.js";
// import { adminPage } from "#templates/pages/adminpage.js";
// import { skjemaPage } from "#scripts/skjema.js";
// import { convertJSON } from "#scripts/convertjson.js";
import { cookieDelete } from "#scripts/cookie_control";
import { ensureLogedin, logout } from "#scripts/idporten.js";
import WebFont from "webfontloader";
import { UserManager } from 'oidc-client-ts';
import 'construct-style-sheets-polyfill';
import * as Sentry from "@sentry/browser";
import posthog from 'posthog-js'

export const startMeUp = (_evnt) => {
	const bodyEl = document.body || document.getElementsByTagName("body")[0];
	const version = bodyEl?.dataset.version || "";
	const pageInfo = window.pageInfo || (window.pageInfo = {});

	(async () => {
		try {
			const resp = await fetch("https://prokom-aimcms.azurewebsites.net/api/Public/version", { cache: "no-store" });
			if (resp.ok) {
				const j = await resp.json();
				const apiVersion = j?.version || j?.fileVersion || j?.informationalVersion || bodyEl.dataset.apiversion || null;
				pageInfo.apiVersion = apiVersion;
				if (apiVersion) {
					bodyEl.dataset.apiversion = apiVersion;
				}
			}
		} catch (error) {
			console.warn("Failed to retrieve API version", error);
		}
	})();

	if (sessionStorage.getItem("cookiePreference") !== "rejected" || window.dev) {
		const sentryDebug = false;
		let sentryDsn = "";
		let sentryTracesSampleRate = 0.01;
		let sentryTracePropagationTargets = [/^https: \/\/[a-zA-Z0-9-]+\.aim\.prokom\.no/, /^https:\/\/[a-zA-Z0-9-]+\.kommune\.no/];
		let sentryIntegration = [
			Sentry.browserTracingIntegration(),
			Sentry.captureConsoleIntegration({ levels: ["warn", "error"] }),
		];
		let sentryEnvironment = "unknown";

		if (window.location.host.match(/localhost/gim)) {
			// Environment: localhost use GlitchTip
			sentryDsn = "https://fe0712a6fe48401da88bf81c0093abd2@glitchtip.backstage.prokom.no/1";
			sentryTracePropagationTargets = [/^https:\/\/localhost/];
			sentryEnvironment = "localhost";
		} else if (window.dev && window.AimCookies.RuntimeDeveloper === "dev") {
			// Environment: all dev environment
			sentryDsn = "https://fe0712a6fe48401da88bf81c0093abd2@glitchtip.backstage.prokom.no/1";
			sentryTracePropagationTargets = [/^https:\/\/.*aim\.prokom\.no/, /^https\/\/.*\.kommune\.no/];
			sentryEnvironment = window.AimCookies.RuntimeDeveloper;
		} else {
			// Environment: production use Sentry
			sentryDsn = "https://d7c584aa121c14d7f88ef8696ed17cde@o4508376266309632.ingest.de.sentry.io/4508376494702672",
				sentryTracesSampleRate = 0.01;
			sentryEnvironment = "production";
		}

		Sentry.init({
			// dsn: "https://d7c584aa121c14d7f88ef8696ed17cde@o4508376266309632.ingest.de.sentry.io/4508376494702672",
			// dsn: "https://fe0712a6fe48401da88bf81c0093abd2@glitchtip.backstage.prokom.no/1",
			dsn: sentryDsn,
			ignoreErrors: [
				/^\[WebComponentDevTools\]/,
				/Load failed/,
				/Failed to fetch/,
				/^GSAP.*/,
				"Non-Error promise rejection captured",
				"Non-Error exception captured",
				"Can't find variable: gmo",
				"Couldn't load preload assets",
				"missing ) after argument list",
				"System.import is not a function"
			],
			maxBreadcrumbs: 5,
			release: `aim-frontend@${version}`,
			debug: sentryDebug,
			denyUrls: [/https?:\/\/((cdn|www|api)\.)?skjema\.no/, /https?:\/\/prokomresources\.prokomcdn\.no/],
			integrations: sentryIntegration,
			tracesSampleRate: sentryTracesSampleRate,
			tracePropagationTargets: sentryTracePropagationTargets,
			environment: sentryEnvironment,
			// Session Replay
			// replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
			// replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
			beforeSend: (event) => {
				return shouldIgnoreError(event) ? null : event;
			},
		});
		Sentry.setTag("customer", window.serverdata?.configMeta?.aim?.nameId);
	}

	// if (window.location.host.match(/localhost/gim) || window.dev && window.AimCookies.RuntimeDeveloper === "dev") {
	// 	posthog.init('phc_LryxFEFWr0p0Qf87FR6IveMTxjxuDdB7j455MdKEkiL',
	// 		{
	// 			api_host: 'https://eu.i.posthog.com',
	// 			person_profiles: 'always'
	// 			// person_profiles: 'identified_only' // or 'always' to create profiles for anonymous users as well
	// 		}
	// 	)
	// }

	let maincontent = "";
	const template = getPageUrl().template;
	window.serverdata.configMeta.aim = Object.assign({}, { template }, window.serverdata.configMeta.aim);
	window.searchEngine = window.serverdata.configMeta.aim.searchEngine || "https://prokom.aim.ayfie.com";

	const currentLanguage = localStorage?.getItem("currentLanguage")?.substring(0, 2) || window.serverdata.configMeta.aim.lang || "nb";
	document.documentElement.setAttribute("lang", currentLanguage);

	window.googleTranslateLanguages = window.serverdata.configMeta.aim.languageSelector?.googleTranslateLangs;

	// Check for redirects in CMS
	window.clientRedirects = [];
	const redirectsUrl = `${window.apiUrl}/AdminApi/getredirects/${window.serverdata.configMeta.aim.clientId}`;
	fetch(redirectsUrl)
		.then(response => {
			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}
			return response.json();
		})
		.then(redirects => {
			window.clientRedirects = redirects;
			const hasRedirect = window.clientRedirects ? window.clientRedirects.filter((r) => r.oldUrl === window.location.pathname) : undefined;
			if (hasRedirect.length > 0) {
				const redirectUrl = hasRedirect[0].newUrl;
				console.log(`Redirecting from ${window.location.pathname} to ${redirectUrl}...`);

				const urldivert = redirectUrl.substr(1).split(/\/(.+)/);
				const pageTemplate = urldivert[0] || "frontpage";
				const pageContentid = urldivert[1] || "";
				// replace the url in history then redirect
				history.replaceState(null, "", `${window.location.origin}/${pageTemplate}/${pageContentid}`);
				window.location.href = `${window.location.origin}/${pageTemplate}/${pageContentid}`;
			}
			const isValidUrl = checkValidPath();
			if (!isValidUrl) {
				AimWarn("Invalid path", window.location);
				window.location.replace(`${window.location.origin}/404`);
			}
		});

	// end redirect check

	if (window.serverdata.configMeta.aim.favicon) {
		function setFavicons (favImg) {
			const headTitle = document.querySelector("head");
			const setFavicon = document.createElement("link");
			setFavicon.setAttribute("rel", "shortcut icon");
			setFavicon.setAttribute("href", favImg);
			headTitle.appendChild(setFavicon);
		}
		setFavicons(window.serverdata.configMeta.aim.favicon);
	}

	sessionStorage.setItem("config", JSON.stringify(window.serverdata.configMeta.aim));

	const cssVariables = {};

	// $.each(window.serverdata.configMeta.aim.css, (nr, obj) => {
	// 	document.documentElement.style.setProperty(`--${obj.prop}`, obj.value);
	// 	cssVariables[obj.prop] = obj.value;
	// });

	// add class for Kari background
	// const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	// if (!isSafari) {
	const sheet = new CSSStyleSheet(); //needs polyfill for iOS (construct-style-sheets-polyfill)
	sheet.replaceSync(
		`.clsx-1 { fill: ${window.serverdata.configMeta.aim.karicolors?.backgroundColor ? window.serverdata.configMeta.aim.karicolors?.backgroundColor : "#ffffff"}; }`,
	);
	document.adoptedStyleSheets = [sheet];
	// }

	let devStyles = "";
	if (window.AimCookies.DevStyles) {
		devStyles = `devstyle_${window.AimCookies.DevStyles}`;
	}

	let cssStyle = "";

	if (window.AimCookies.DevStyles !== "" && window.serverdata.configMeta.aim[devStyles]) {
		cssStyle = window.serverdata.configMeta.aim[devStyles];
	} else {
		cssStyle = window.serverdata.configMeta.aim.style;
	}

	if (cssStyle) {
		for (const [prop, value] of Object.entries(cssStyle)) {
			if (typeof value === "object") {
				for (const [prop2, value2] of Object.entries(value)) {
					document.documentElement.style.setProperty(`--${prop}__${prop2}`, value2);
					cssVariables[`${prop}__${prop2}`] = value2;
				}
			} else {
				document.documentElement.style.setProperty(`--${prop}`, value);
				cssVariables[prop] = value;
			}
		}
	}

	// load dynamic fonts
	const fontList = [];
	window.serverdata.configMeta.aim?.fonts?.fontsToLoad?.forEach((font, i) => {
		fontList.push(font);
	});
	if (fontList.length > 0) {
		WebFont.load({
			google: {
				families: fontList,
			},
		});
	}
	if (window.serverdata.configMeta.aim?.fonts?.header?.FontFace !== undefined) {
		document.documentElement.style.setProperty("--header__font__family", window.serverdata.configMeta.aim?.fonts?.header?.FontFace);
	}

	if (window.serverdata.configMeta.aim?.fonts?.basis?.FontFace !== undefined) {
		document.documentElement.style.setProperty("--font__family", window.serverdata.configMeta.aim?.fonts?.basis?.FontFace);
	}

	// CHECK LOGGIN
	localStorage.setItem("loginRedirect", window.location.href);
	if (document.referrer.match(/(https:\/\/aim-admin.*azurewebsites.net)/gi) || document.referrer.match(/(https:\/\/admin.aimcms.no)/gi)) {
		sessionStorage.setItem("fromcms", true);
	}

	const configOidcAim = {
		authority: "https://identity.prokom.no",
		client_id: "AimPreviewClient",
		redirect_uri: `${location.origin}/callback.html`,
		response_type: "code",
		scope: "openid profile aim_api",
		post_logout_redirect_uri: `${location.origin}/logout-callback.html`,
	};
	window.mgr = new UserManager(configOidcAim);
	window.mgr.getUser().then((user) => {
		if (user || window.location.host.match(/localhost/gim)) {
			if (user) {
				localStorage.setItem("access_token", user?.access_token || "localhost");
				localStorage.setItem("access_pid", user?.profile?.pid);
				localStorage.setItem("user_email", user?.profile.email);
				// posthog.identify(
				// 	user?.profile?.pid,
				// 	{ email: user?.profile.email, Client: window.serverdata.configMeta.aim.clientId } // optional: set additional person properties
				// );
			}

			if (window.getUrlAttr("preview")) {
				localStorage.setItem("fromcms", "true");
				document.body.insertAdjacentHTML('beforeend', `
									<div class="alert alert-warning fixed-bottom mb-0" role="alert">
											<div class="container"><div class="row"><div class="col-12">
													Du er nå på forhåndsvisning av siden. Klikk <a href="${location.origin}${location.pathname}" >her</a> for å se live versjon.
											</div></div></div>
									</div>`);
			}
		} else {
			if (window.getUrlAttr("preview") || window.serverdata.configMeta.aim.template === "admin" || window.getUrlAttr("login")) {
				window.mgr.signinRedirect();
			}
		}
	});

	if (template === "minside" && !window.location.host.match(/localhost/gim)) {
		ensureLogedin();
	}
	header();

	function checkScriptExists () {
		if (window.serverdata.configMeta.aim.languageSelector?.showGoogleLanguages === true) {
			const googleScriptUrl = "//translate.google.com/translate_a/element.js";
			const scripts = document.querySelectorAll('script');
			const scriptExists = Array.from(scripts).some(script => script.src.includes(googleScriptUrl));
			if (scriptExists) {
				// Ensure google.translate object exists
				if (typeof google !== "undefined" && google.translate && google.translate.TranslateElement) {
					// run google translate function
					/* eslint-disable no-undef */ // <-- Allow no-undef starting from here
					google.translate.TranslateElement(
						{
							pageLanguage: "no",
							includedLanguages: window.googleTranslateLanguages,
							layout: 2, //google.translate.TranslateElement.InlineLayout.SIMPLE,
						},
						"google_translate_element",
					);
					/* eslint-enable no-undef */ // <-- Remove no-undef rules exception here
					clearInterval(timer);
				}
			}
		}
		clearInterval(timer);
		return;
	}
	const timer = setInterval(checkScriptExists, 1500);

	const config = window.serverdata.configMeta.aim;
	const clientId = config.clientId;
	const menucategoryUrl = `${window.apiUrl}/PublicContentApi/menucategory/${clientId}`;

	function fetchNavData () {
		return fetch(menucategoryUrl)
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				return response.json();
			});
	}

	async function initPage () {
		try {
			const config = window.serverdata.configMeta.aim;
			const clientId = config.clientId;
			const menucategoryUrl = `${window.apiUrl}/PublicContentApi/menucategory/${clientId}`;

			const navdata = await fetch(menucategoryUrl)
				.then(res => {
					if (!res.ok) throw new Error(`HTTP error ${res.status}`);
					return res.json();
				});

			storeNav(navdata)
			$(".fullnav__main").html(headerNav());

			const maincontent = getTemplateContent(template, config, navdata);

			if (maincontent !== null) {
				$("#maincontent").html(maincontent);
			}

			document.body.classList.add(`${template}_template`);
		} catch (err) {
			console.error("Failed to initialize page", err);
		}
	}

	initPage();

	$("#footer").html(footer());

	if (typeof window.cssVars === "function") {
		window.cssVars({
			watch: true,
			variables: cssVariables,
		});
	}

	window.FantDu.startTrace("ssp_fantdu", window.serverdata.configMeta.aim.nameId, _evnt);

	// Environment indicator and cookie delete handler
	const insertBanner = (html) => {
		document.body.insertAdjacentHTML("beforeend", html);
	};

	const env = window.AimCookies.RuntimeMode;
	if (env) {
		const banners = {
			dev: `<div class="alert alert-primary fixed-bottom mb-0" role="alert">
            Du ser nå siden i <strong><u>Dev</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
          </div>`,
			qa: `<div class="alert alert-primary fixed-bottom mb-0" role="alert">
            Du ser nå siden i 🐄 modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
         </div>`,
			staging: `<div class="alert alert-warning fixed-bottom mb-0" role="alert">
                Du ser nå siden i <strong><u>Staging</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
              </div>`,
			release: `<div class="alert alert-warning fixed-bottom mb-0" role="alert">
                Du ser nå siden i <strong><u>Release</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
              </div>`,
			preprod: `<div class="alert alert-danger fixed-bottom mb-0" role="alert">
                Du ser nå siden i <strong><u>PreProd</u></strong> modus. (Data kommer fra <strong><u>PROD</u></strong> databasen) <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
              </div>`,
			prod: `<div class="alert alert-danger fixed-bottom mb-0" role="alert">
              Du ser nå siden i <strong><u>Prod</u></strong> modus. <a href="#" class="cookie-delete">Fjern Cookie</a> for å gå til live visning.
           </div>`
		};
		if (banners[env]) insertBanner(banners[env]);
	}

	document.body.addEventListener("click", (e) => {
		if (e.target.classList.contains("cookie-delete")) {
			cookieDelete("RuntimeMode");
			location.reload();
		}
	});
};

function shouldIgnoreError (error) {
	return isProbablyBlockedByAdblockNetworkError(error);
}

function isProbablyBlockedByAdblockNetworkError (error) {
	const now = Date.now();

	if (!error.breadcrumbs) {
		return false;
	}

	// We go from the back since the last breadcrumb is most likely the erroneous one
	for (let i = error.breadcrumbs.length - 1; i >= 0; i--) {
		const breadcrumb = error.breadcrumbs[i];
		if (!breadcrumb) continue;

		// We only need to check the last 5s of breadcrumbs as any earlier breadcrumbs are definitely unrelated
		if (breadcrumb.timestamp && now - breadcrumb.timestamp * 1000 > 5000) {
			break;
		}

		if (isProbablyBlockedByAdblockBreadcrumb(breadcrumb)) {
			return true;
		}
	}

	return false;
}

function isProbablyBlockedByAdblockBreadcrumb (breadcrumb) {
	if (breadcrumb.level !== "error" || (breadcrumb.category !== "xhr" && breadcrumb.category !== "fetch")) {
		return false;
	}

	const url = breadcrumb.data?.url;
	if (!url) return false;

	return isProbablyBlockedByAdblockUrl(url);
}

function isProbablyBlockedByAdblockUrl (url) {
	try {
		if (["viewer.min.js", "sspkalender.prokom.no", "api.friskus.com", "007prokom.boost.ai"].includes(url)) return true;
	} catch {
		return true;
	}
	return false;
}
